import {
  Accordion,
  AccordionItem,
  AccordionTitle,
  Button,
  ButtonWithIcon,
  ButtonWithTextIcon,
  Dropdown,
  LinkRoute,
  SearchBar,
  Textbox,
} from "../ui";
import {
  AddUser,
  ArrowDown,
  Block,
  Close,
  Edit,
  Filter,
  Share,
  StashBoard,
  Vision,
  Save,
} from "../ui/icons";
import { B1, B3, H1, H2, H3, L } from "../ui/Typography";
import React, { useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import LogInDialogBox from "../pages/auth/LogInDialogBox";
import SignupDialogBox from "../pages/auth/SignUpDialogBox";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../redux/reducers/AuthReducer";

/* images */
import profileIcon from "../assets/images/profile-icon.png";
import TempLogIn from "../pages/auth/TempLogIn";
import TempSignUp from "../pages/auth/TempSignUp";
/* end images */

const MainLayout = () => {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user); // get user if logged in
 /*  console.log("sdfsf", user); */
  /*start searching data*/
  const sampleData = [
    { id: 1, label: "Elon Dusk" },
    { id: 2, label: "Mark Fckerberg" },
    { id: 3, label: "Bill Wiaites" },
    { id: 4, label: "Aam Saltman" },
    { id: 5, label: "Undar Pichai" },
    { id: 6, label: "Gautam Armani" },
    { id: 7, label: "Narendra Gandihi" },
    { id: 8, label: "Bitcoin" },
    { id: 9, label: "Binary" },
    { id: 10, label: "Biscuits" },
    { id: 11, label: "Bishop" },
    { id: 12, label: "Bisexual" },
    { id: 13, label: "Bi product" },
    { id: 14, label: "Bitter" },
    { id: 15, label: "Big Water melons" },
  ];
  /*end searching data*/
  /* start get location for add active class */
  const location = useLocation();
  /* end get location for add active class */
  /* start edit profile code */
  const [isEditing, setIsEditing] = useState(false);
  const [isModified, setIsModified] = useState(false);

  // State for inputs (you can initialize these from props or API)
  const [contact, setContact] = useState((user && user.Contact) || "xxx xxx xxxx"); 
  const [address, setAddress] = useState(
    "47 W 13th St, New York, NY 10011, USA"
  );

  // Handlers
  const handleEditClick = () => {
    if (isEditing && isModified) {
      // Save logic
      setIsEditing(false);
      setIsModified(false);
    } else if (isEditing && !isModified) {
      // Cancel edit
      setIsEditing(false);
    } else {
      // Enter edit mode
      setIsEditing(true);
    }
  };

  const handleInputChange = (setter) => (e) => {
    setter(e.target.value);
    setIsModified(true);
  };

  /* end edit profile code */

  /* start login model logic */

  const [openModal, setOpenModal] = useState(null); // null | 'login' | 'signup'

  const openLogin = () => setOpenModal("login");
  const openSignup = () => setOpenModal("signup");
  const closeModal = () => setOpenModal(null);

  /* end login model logic */

  return (
    <div className="main-layout">
      <aside className="sidebar">
        <nav className="nav">
          <div className="navbar-wrapper borderWrapper">
            <div className="navbar-container borderInner">
              <ul>
                <li>
                  <Link
                    to="/"
                    className={`${
                      location.pathname === "/" ? "active" : ""
                    } navbar-link`}
                  >
                    <StashBoard className="sidebar-icon" size="lg" />
                    <B3>Stashboard</B3>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/vision"
                    className={`${
                      location.pathname.startsWith("/vision") ? "active" : ""
                    } navbar-link`}
                  >
                    <Vision className="sidebar-icon" size="lg" />
                    <B3>Vision</B3>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/blocks"
                    className={`${
                      location.pathname.startsWith("/blocks") ? "active" : ""
                    } navbar-link`}
                  >
                    <Block className="sidebar-icon" size="lg" />
                    <B3>Blocks</B3>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          {/* <Link to="/">Home</Link> |{" "}
          <Link to="/showcase">UI Showcase</Link> */}
        </nav>
      </aside>
      <main className="main-content">
        <div className="main-content-wrapper">
          <div className="header">
            <div className="header-left">
              <H1 className="heading-title">Good Evening Pal. ^_^</H1>
              <div className="header-search-filter">
                <SearchBar
                  size="lg"
                  data={sampleData}
                  placeholder="tell us what you are looking for"
                  className="search-bar"
                />
                <ButtonWithIcon size="lg" icon={Filter} />
              </div>
            </div>
            <div className="header-right">
              {!user ? (
                <>
                  <Button
                    onClick={() => openLogin()}
                    size="lg"
                    className="login-btn"
                  >
                    Log In
                  </Button>
                  <TempLogIn
                    isOpen={openModal === "login"}
                    onClose={closeModal}
                    onSwitchToSignup={openSignup}
                  />
                  <TempSignUp
                    isOpen={openModal === "signup"}
                    onClose={closeModal}
                    onSwitchToLogin={openLogin}
                  />
                </>
              ) : (
                <Accordion size="lg" className="header-profile-wrapper">
                  <AccordionItem>
                    <AccordionTitle>
                      <div className="header-profile-container ">
                        <div className="header-profile-avatar borderWrapper">
                          <div className="borderInner">
                            <img
                              src={profileIcon}
                              className="profile-icon "
                              alt="profile-icon"
                            />
                          </div>
                        </div>
                        <div className="header-profile-user-details">
                          <H3 className="user-name">{user.First_Name || 'Elon'} {user.Last_Name || 'melon'}</H3>
                          <B1 className="email">{user.Email}</B1>
                          <B1 className="user-code">Whats80982ehdsn23</B1>
                        </div>
                      </div>
                    </AccordionTitle>
                    <div
                      className={`profile-more-details-box ${
                        isEditing ? "editing" : ""
                      }`}
                    >
                      <div className="profile-more-details">
                        <L size="md" className="profile-label">
                          Contact no.
                        </L>
                        {!isEditing && (
                          <B1 className="profile-text">{contact}</B1>
                        )}
                        {isEditing && (
                          <Textbox
                            type="text"
                            placeholder="Contact Number"
                            size="md"
                            name="contact-number"
                            className="edit-profile-text"
                            value={contact}
                            onChange={handleInputChange(setContact)}
                          />
                        )}
                      </div>

                      <div className="profile-more-details">
                        <L size="md" className="profile-label">
                          Address
                        </L>
                        {!isEditing && (
                          <B1 className="profile-text">{address}</B1>
                        )}
                        {isEditing && (
                          <Textbox
                            type="text"
                            placeholder="Address"
                            size="md"
                            name="address"
                            className="edit-profile-text"
                            value={address}
                            onChange={handleInputChange(setAddress)}
                          />
                        )}
                      </div>

                      <div className="profile-more-details">
                        <L
                          size="md"
                          className="profile-label select-user-dropdown"
                        >
                          Switch user
                        </L>
                        <Dropdown
                          name="pixel-select"
                          size="md"
                          placeholder="Select user"
                          className="profile-user-selector"
                          options={[
                            { label: "Option 1", value: "opt1" },
                            { label: "Option 2", value: "opt2" },
                            { label: "Option 3", value: "opt3" },
                          ]}
                          disabled={isEditing}
                        />
                      </div>

                      <div className="profile-more-details-btn">
                        <Button onClick={() => dispatch(logout())}>
                          Log out
                        </Button>
                        <ButtonWithTextIcon
                          size="md"
                          variant="primary"
                          icon={AddUser}
                          disabled={isEditing}
                        >
                          Add User
                        </ButtonWithTextIcon>

                        <ButtonWithIcon
                          icon={Share}
                          size="md"
                          disabled={isEditing}
                        />

                        <ButtonWithIcon
                          icon={isEditing ? (isModified ? Save : Close) : Edit}
                          size="md"
                          onClick={handleEditClick}
                        />
                      </div>
                    </div>
                  </AccordionItem>
                </Accordion>
              )}
              {/* <div className="header-profile-wrapper borderWrapper">
                <div className="header-profile-container borderInner">
                  <div className="header-profile-avatar borderWrapper">
                    <div className="borderInner">
                      <img
                        src={profileIcon}
                        className="profile-icon "
                        alt="profile-icon"
                      />
                    </div>
                  </div>
                  <div className="header-profile-user-details">
                    <H2>Elon melon</H2>
                    <B1 className="email">Elonmemlon@gmail.com</B1>
                    <B1 className="user-code">Whats80982ehdsn23</B1>
                  </div>
                  <ArrowDown size="lg" />
                </div>
              </div> */}
            </div>
          </div>
          <div className="dynamic-content">
            <Outlet />
          </div>
        </div>
        {/* <Link to="/showcase">UI Showcase</Link> */}
      </main>
    </div>
  );
};

export default MainLayout;
